import "./Audit.module.css";
import Header from "@/reusable_sections/Header";
import AuditHero from "./sections/AuditHero";
import WhatIsTheAdministrativeLeak from "./sections/WhatIsTheAdministrativeLeak";
import HowTheAuditWorks from "./sections/HowTheAuditWorks";
import Footer from "@/reusable_sections/Footer";
export default function AuditPage() {
  return <div>
      <Header />
      <AuditHero />
      <WhatIsTheAdministrativeLeak />
      <HowTheAuditWorks />
      <Footer />
    </div>;
}